import React from 'react'
import { Card, Button, Box, Typography, Grid } from '@mui/material'
import RFG from "../../libs/inputs/RFG"
import { useDispatch, useSelector } from "react-redux"
import { useForm } from 'react-hook-form'
import { LOGIN } from "../../services/actions"
import { BsEyeFill, BsEyeSlashFill } from "react-icons/bs"
import { useNavigate } from 'react-router-dom'
import authImg from './auth.jpeg'
import OtpTimer from './OtpTimer'

export default function Login() {
  const navigate = useNavigate()
  let dispatch = useDispatch()
  let user = useSelector((state) => state?.loginState.auth)
  const [verify, setVerify] = React.useState(false)
  const [erroMsg, setErrorMsg] = React.useState("")
  const { handleSubmit, control } = useForm({
    // defaultValues: { "username": "admin@gmail.com", password: "Admin@123" },
    mode: "all"
  })
  React.useEffect(() => {
    console.log("RESULT", user ? "user" : "anonymous", user)
    if (Object.keys(user || {}).length) {
      setVerify(user?.status || false)
      console.log("EXPIRY1", localStorage.expiry)
      localStorage.expiry = localStorage.expiry <= 0 ? user.expiry : localStorage.expiry
      console.log("EXPIRY", localStorage.expiry)
    } else if (verify) {
      setErrorMsg("Invalid otp")
    }
  }, [user])
  return (
    <>
      <Box display={'flex'} alignItems={'center'} justifyContent={'center'}
        sx={{
          width: 1, height: '100vh',
          background: '#a4abb6',
        }}>
        <Card sx={{
          minWidth: 210,
          background: 'linear-gradient(130deg, #e3e5e6, #6b859c) no-repeat',
          // backgroundImage: ' linear-gradient(60deg, #e3e5e6,rgb(238, 221, 182),80%)',
          width: 1, mx: { xs: '5%', lg: '10%' }
        }} >
          <Grid container>
            <Grid size={{ xs: 12, sm: 12, md: 5 }}>
              <Box display={'flex'} alignItems={'center'} justifyContent={'center'}
                sx={{
                  width: 1, height: {
                    xs: '65vh',  // laptops
                    lg: '80vh',  // desktops
                  }, p: { xs: '10%', lg: '20%' }
                }}>
                <Box>
                  <Box sx={{ textAlign: 'center', }}>
                    <Typography fontSize={16} fontWeight={800} color="#1c1b1bff">Sign In Access</Typography>
                    <Typography fontSize={13} sx={{ my: 2 }} color="#1c1b1bff">Welcome to widelapse monitoring system</Typography>
                  </Box>
                  <form autoComplete="false" onSubmit={handleSubmit((data) => {
                    setErrorMsg("")
                    data.verify = verify;
                    if (!data.password) {
                      data.password = "0000";
                    }
                    dispatch({ type: `${LOGIN}_AUTH`, payload: data });
                  })}>
                    {!verify && <>
                      <RFG labelStyle={{ color: "#1c1b1bff" }} name="username" label="Email as Username" control={control} rules={{ required: true }} className="mb-2">
                        <input placeholder='Enter email' autoComplete="false" style={{ borderRadius: 12, color: "#1c1b1bff" }} />
                      </RFG>
                    </>}
                    {verify && <>


                      <RFG labelStyle={{ color: "#1c1b1bff" }} name="password" label="OTP" control={control} rules={{ required: true }} className="mb-2">
                        <input placeholder='Enter OTP' style={{ borderRadius: 12, color: "#1c1b1bff" }} type="password" />
                      </RFG>

                      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <Typography sx={{ mt: 1, fontSize: 11, textAlign: 'right', color: "#1c1b1bff" }}>
                          {user?.status && <OtpTimer expiry={localStorage.expiry} />}
                        </Typography>
                        <Typography sx={{ mt: 1, fontSize: 12, textAlign: 'right', color: "#1c1b1bff", cursor: 'pointer' }}
                          onClick={() => { navigate('/forgot-password/') }}
                        >Resend OTP</Typography>
                      </Box>
                    </>
                    }
                    <Box display={'flex'} justifyContent={'space-between'} gap={2}>
                      {verify && <Button onClick={() => { setVerify(false); setErrorMsg("") }} sx={{ color: "white", width: 1, mt: 2, background: '#4b618dff', borderRadius: 2 }}>Login</Button>}
                      <Button sx={{ color: "white", width: 1, mt: 2, background: '#3f5175', borderRadius: 2 }} type="submit">{verify ? <span>Verify</span> : <span>Login</span>}</Button>
                    </Box>
                  </form>
                  <Typography color="#f85757ff" fontSize={13}>{erroMsg}</Typography>

                  <Box fontSize={12} className="error">{user?.message}</Box>
                  <Box display={'flex'} alignItems={'center'} justifyContent={'space-between'}>
                    <Typography sx={{ mt: 2, fontSize: 12, textAlign: 'right', color: "#717171" }}>Powered by widelapse</Typography>
                    <Typography sx={{ mt: 2, fontSize: 12, textAlign: 'right', color: "#717171" }}>Terms & conditions</Typography>
                  </Box>
                </Box>
              </Box>

            </Grid>
            <Grid size={{ xs: 12, sm: 12, md: 7 }} sx={{ p: '1%', display: { xs: 'none', sm: 'none', md: 'block' } }}>
              <Box display={'flex'} alignItems={'center'} justifyContent={'end'}
                sx={{
                  width: 1, height: '80vh', overflow: 'hidden', borderRadius: 3
                }}>
                <img height={'100%'} src={authImg} />
              </Box>
            </Grid>
          </Grid>

        </Card>
      </Box >
    </>
  )
}

